import {
    TRADING_HISTORY_READY,
    TRADING_HISTORY_LOADING,
    TRADING_HISTORY_ERROR,
    UPLOAD_DOCS_SUCCESS,
    UPLOAD_DOCS_ERROR,
    FETCH_UPLOADED_DOCS,
    UPLOAD_DOCS_LOADING,
    REMOVE_UPLOAD_DOCS_ALERT,
    REMOVE_ERRORED_DOC,
    TRADING_HISTORY_DOC_STATUS,
    UPDATE_TRADING_HISTORY_DOC_STATUS,
    CUSTOMER_CONFIRMED_DOCS,
    CUSTOMER_CONFIRMED_DOCS_SUCCESS,
    CUSTOMER_CONFIRMED_DOCS_ERROR,
    TRUELAYER_LINKED_LOADING,
    TRUELAYER_LINKED_COMPLETE,
    TRUELAYER_LINKED_ERROR,
    ADD_VAT_MISSING_DOCS,
    REMOVE_VAT_MISSING_DOCS,
    ADD_SPLIT_TEST
} from './actions';
import { DocRequirementTypes, TGetOffersResponse, UploadedFile } from './types';

type TradingHistoryState = {
    loading: boolean;
    error: any;
    selectedOffers: TGetOffersResponse['data']['offers'][number] | null;
    uploadedFiles: UploadedFile[];
    uploadAlerts: UploadedFile[];
    missing: DocRequirementTypes[];
    customer_confirmed_docs: boolean;
    truelayerLoadedOffers: boolean;
    vatToggle: boolean;
    splitTest: { [key: string]: boolean } | null;
};

export const initialState: TradingHistoryState = {
    loading: true,
    error: null,
    selectedOffers: null,
    uploadedFiles: [],
    uploadAlerts: [],
    missing: [],
    customer_confirmed_docs: false,
    truelayerLoadedOffers: false,
    vatToggle: true,
    splitTest: null
};

export default function (state = initialState, action: any) {
    switch (action.type) {
        case TRADING_HISTORY_READY:
            return {
                ...state,
                loading: false,
                selectedOffers: action.selectedOffers,
                loanSummary: action.loanSummary
            };

        case TRADING_HISTORY_LOADING:
            return {
                ...state,
                loading: true
            };
        case TRADING_HISTORY_ERROR:
            return {
                ...state,
                error: action.error,
                loading: false
            };

        case TRADING_HISTORY_DOC_STATUS:
            return {
                ...state,
                missing: action.missing
            };
        case UPDATE_TRADING_HISTORY_DOC_STATUS:
            const uploadedDoc = state.uploadedFiles.map((doc) => {
                // Required check due to inconsistent returns on document_type for upload files vs product offers api.
                if (doc.type === 'business_accounts')
                    return 'company_accounts' as DocRequirementTypes;

                return doc.type;
            });

            const updatedMissingDocs = state.missing.filter(
                (missingDoc) => !uploadedDoc.includes(missingDoc)
            );

            return {
                ...state,
                missing: updatedMissingDocs
            };
        case UPLOAD_DOCS_LOADING:
            return {
                ...state,
                loading: false,
                uploadedFiles: [...state.uploadedFiles, action.payload]
            };

        case UPLOAD_DOCS_SUCCESS: {
            return {
                ...state,
                loading: false,
                uploadedFiles: [
                    ...state.uploadedFiles.filter(
                        (file) => file.loading !== true
                    ),
                    action.payload
                ],
                uploadAlerts: [...state.uploadAlerts, action.payload]
            };
        }
        case FETCH_UPLOADED_DOCS:
            return {
                ...state,
                loading: false,
                uploadedFiles: [...action.payload]
            };

        case UPLOAD_DOCS_ERROR:
            return {
                ...state,
                loading: false,
                uploadedFiles: [
                    ...state.uploadedFiles.filter(
                        (file) => file.loading !== true
                    ),
                    action.payload
                ],
                uploadAlerts: [...state.uploadAlerts, action.payload]
            };

        case REMOVE_ERRORED_DOC:
            const fileToRemove = state.uploadedFiles.find(
                (file) =>
                    file.error &&
                    file.attributes.document_type ===
                        action.file.attributes.document_type &&
                    file.attributes.document_id ===
                        action.file.attributes.document_id
            );

            const updatedUploadedFiles = state.uploadedFiles.filter(
                (file) => file !== fileToRemove
            );

            return {
                ...state,
                error: null,
                loading: false,
                uploadedFiles: updatedUploadedFiles
            };

        case REMOVE_UPLOAD_DOCS_ALERT:
            const updateduploadAlerts = state.uploadAlerts.filter(
                (error) =>
                    error.attributes &&
                    error.attributes['document_id'] !== action.document_id
            );

            return {
                ...state,
                error: null,
                loading: false,
                uploadAlerts: updateduploadAlerts
            };
        case CUSTOMER_CONFIRMED_DOCS:
            return {
                ...state,
                customer_confirmed_docs: false
            };
        case CUSTOMER_CONFIRMED_DOCS_SUCCESS:
            return {
                ...state,
                customer_confirmed_docs: true
            };
        case CUSTOMER_CONFIRMED_DOCS_ERROR:
            return {
                ...state,
                customer_confirmed_docs: false
            };

        case TRUELAYER_LINKED_LOADING:
            return {
                ...state,
                truelayerLoadedOffers: false
            };
        case TRUELAYER_LINKED_COMPLETE:
            return {
                ...state,
                truelayerLoadedOffers: true
            };
        case TRUELAYER_LINKED_ERROR:
            return {
                ...state,
                error: action.error,
                truelayerLoadedOffers: false
            };
        case ADD_VAT_MISSING_DOCS:
            const hasUploadedVAT = state.uploadedFiles.some(
                (doc: UploadedFile) => doc.type === 'vat_return'
            );

            if (hasUploadedVAT) {
                return {
                    ...state
                };
            }

            return {
                ...state,
                vatToggle: true
            };
        case REMOVE_VAT_MISSING_DOCS:
            return {
                ...state,
                vatToggle: false
            };
        case ADD_SPLIT_TEST:
            return {
                ...state,
                splitTest: action.splitTest
            };
        default:
            return state;
    }
}
